/**
 * @file   判断使用设备
 * @author hanzhichen <hanzhichen@baijiahulian.com>
 */

// eslint-disable-next-line import/prefer-default-export
export const isMobile = () => {
    const userAgentInfo = navigator.userAgent.toLowerCase();

    const Agents = [
        'mobile',
        'android',
        'iphone',
        'symbianos',
        'windows phone',
        'ipad',
        'ipod'
    ];

    for (const agent of Agents) {
        if (userAgentInfo.indexOf(agent) !== -1) {
            return true;
        }
    }
    return false;
};
